import { Select, styled ,keyframes } from "@mui/material";

export const StyledSelect: any = styled(Select)`
  &
    .css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    cursor: ${({ $readOnly }: any) => ($readOnly ? "not-allowed" : "pointer")};
  }
`;

const l16 = keyframes`
  0% {
    background-position: -150% 0, -150% 0;
  }
  66% {
    background-position: 250% 0, -150% 0;
  }
  100% {
    background-position: 250% 0, 250% 0;
  }
`;

export const LoaderBar = styled("div")(() => ({
  height: "4px",
  width: "130px",
  "--c": "no-repeat linear-gradient(#6100ee 0 0)",
  background: "var(--c), var(--c), #d7b8fc",
  backgroundSize: "60% 100%",
  animation: `${l16} 3s infinite`,
}));

export const LoaderWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
}));

